const filtersBrands = document.querySelectorAll('.filter_brand input')
const products = document.querySelectorAll('.product-card')
const filtersClear = document.querySelector('.filters_clear')

filtersBrands.forEach(item => {
    item.addEventListener('change', function () {
        let currentFilter = this.dataset.id

        filtersClear.classList.add('clear')

        for (let product of products) {
            product.classList.add('hide')
        }
        
        if (filtersBrands) {
            document.querySelectorAll(`.product-card[data-brand="${currentFilter}"]`).forEach(item => {
                item.classList.remove('hide')
            })
        }
    })
})

filtersClear.addEventListener('click', function() {

    products.forEach(item => {
        item.classList.remove('hide')
    })

    filtersBrands.forEach(item => {
        item.checked = false
    })

    filtersClear.classList.remove('clear')
})